<template>
    <div :class="$style.wrapper">
        <el-pagination
            background
            layout="prev, pager, next"
            :current-page="page"
            :page-count="pageCount"
            @current-change="pageChange"
        >
        </el-pagination>
    </div>
</template>

<script>
    export default {
        props: ['currPage', 'pageCount', 'pageChange'],
        data () {
            return {
                page: 1,
            };
        },
        watch: {
            page(val) {
                this.$emit('update:currPage', val);
            }
        }
    };
</script>

<style lang="less" module>
    .wrapper {

    }
</style>



// WEBPACK FOOTER //
// src/components/Common/Pagination.vue